module.exports = __webpack_public_path__ + "img/Startup Verband.44ee5fdc.svg";